/**
 * Created by neo on 26.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { FitnessProgramTemplateQueryRequest } from './FitnessProgramTemplateQueryRequest';
import { Pageable } from '../../../Interfaces/Pageable';
import { HttpBackend } from '../../../../Services/Http/HttpBackend';
import { LocalizedNamedEntity, createLocalizedNamedEntity } from '../../../LocalizedNamedEntity';

export type FitnessProgramTemplateCategory = LocalizedNamedEntity & {
  order: number;
  query: FitnessProgramTemplateQueryRequest;
};

export function createFitnessProgramTemplateCategory(json?: Partial<FitnessProgramTemplateCategory>): FitnessProgramTemplateCategory {
  const base = createLocalizedNamedEntity(json as any);
  let query = json?.query ?? {};
  // "fix" query object by removing null values
  query = Array.from(Object.entries(query)).reduce(
    (agg, [key, value]) => (value !== undefined && value !== null ? Object.assign(agg, { [key]: value }) : agg),
    {},
  );

  return makeAutoObservable({
    ...base,
    order: json?.order ?? 0,
    query,
  });
}

export const FitnessProgramTemplateCategoryApi = {
  find(request?: Pageable): Promise<FitnessProgramTemplateCategory[]> {
    return HttpBackend.get(`/coach/program/template/category`, request).then((res) =>
      (res ?? []).map((r: any) => createFitnessProgramTemplateCategory(r)),
    );
  },
};
